import { SVGProps } from 'react';

const Barcode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 5v14M8 5v14m4-14v14m5-14v14m4-14v14"
    />
  </svg>
);
export default Barcode;
